
import { mapGetters } from "vuex";

import { JOB_BOARD_REMOTE_PATH } from "~/utils/startScreen";

export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      accountLoading: false,
      accountMenuItems: [
        {
          icon: "mdi-account-circle",
          title: "My Account",
          to: "/my-account",
          // to: "/users/{current_user}"
        },
        {
          icon: "mdi-exit-to-app",
          title: "Logout",
          click: function () {
            this.accountLoading = true;
            this.$auth.logout().then(() => {
              this.accountLoading = false;
              this.$router.push({
                path: "/login",
              });
            });
          }.bind(this),
        },
        {
          icon: "mdi-bug",
          title: "Toggle Debug",
          click: function () {
            // add debug query to current url
            let url = new URL(window.location.href);
            url.searchParams.set("debug", this.$config.debug ? "0" : "1");
            location.href = url.href;
          }.bind(this),
          adminOnly: true,
        },
      ],
      allPrimaryMenuItems: [
        {
          icon: "mdi-format-list-numbered",
          title: "Jobs Schedule",
          to: "/jobs-schedule",
        },
        {
          icon: "mdi-television-guide",
          title: "Job Board",
          // The interactive surface, not the wall display: the TV view is
          // loaded by the kiosk itself with a board token.
          to: JOB_BOARD_REMOTE_PATH,
        },
        {
          icon: "mdi-account-hard-hat",
          title: "Crews",
          to: "/crews",
        },
        {
          icon: "mdi-calendar",
          title: "My Appointments",
          to: "/events?user={current_user}",
        },
        {
          icon: "mdi-map",
          title: "Jobs on Map",
          to: "/jobs-on-map",
        },
        {
          icon: "mdi-receipt",
          title: "Balances Due",
          to: "/balances-due",
        },
        {
          icon: "mdi-chart-bar",
          title: "Metrics / Reports",
          to: "/metrics",
          adminOnly: true,
        },
        {
          icon: "mdi-file-document-edit-outline",
          title: "Completed Jobs",
          to: "/completed-jobs",
        },
      ],
      allSecondaryMenuItems: [
        {
          icon: "mdi-domain",
          title: "Accounts",
          to: "/accounts",
        },
        {
          icon: "mdi-account",
          title: "Contacts",
          to: "/contacts",
        },
        {
          icon: "mdi-calendar",
          title: "Appointments",
          to: "/events",
          adminOnly: true,
        },
        {
          icon: "mdi-phone",
          title: "Calls",
          to: "/calls",
        },
        {
          icon: "mdi-file-document-edit-outline",
          title: "Contracts",
          to: "/contracts",
        },
        {
          icon: "mdi-currency-usd",
          title: "Expenses",
          to: "/expenses",
          adminOnly: true,
        },
        {
          icon: "mdi-receipt",
          title: "Invoices",
          to: "/invoices",
          adminOnly: true,
        },
        {
          icon: "mdi-credit-card-outline",
          title: "Payments ",
          to: "/payments",
          adminOnly: true,
        },
        {
          icon: "mdi-account-multiple",
          title: "Users",
          to: "/users",
          adminOnly: true,
        },
        {
          icon: "mdi-message-badge-outline",
          title: "Notifications",
          to: "/notification-overview",
          adminOnly: true,
        },
        {
          icon: "mdi-trash-can-outline",
          title: "Deleted Entries",
          visibility: ["admin"],
          subItems: [
            {
              icon: "mdi-domain",
              title: "Accounts",
              to: "/deleted/Account",
            },
            {
              icon: "mdi-account",
              title: "Contacts",
              to: "/deleted/Contact",
            },
            {
              icon: "mdi-phone",
              title: "Calls",
              to: "/deleted/Call",
            },
            {
              icon: "mdi-file-document-edit-outline",
              title: "Contracts",
              to: "/deleted/Contract",
            },
            {
              icon: "mdi-receipt",
              title: "Invoices",
              to: "/deleted/Invoice",
              adminOnly: true,
            },
            {
              icon: "mdi-credit-card-outline",
              title: "Payments",
              to: "/deleted/Payment",
              adminOnly: true,
            },
            {
              icon: "mdi-account-multiple",
              title: "Users",
              to: "/deleted/User",
              adminOnly: true,
            },
          ],
        },
      ],
      miniVariant: false,
    };
  },
  mounted() {
    if (typeof this.$route.query.debug !== "undefined") {
      this.$config.debug = this.$route.query.debug == "1" ? true : false;
    }
    // The drawer is `app fixed` with no `permanent`, so below the mobile
    // breakpoint Vuetify renders it temporary -- an open drawer is then a
    // full-viewport overlay on every authenticated page. $nextTick because
    // VNavigationDrawer's own mounted() hasn't finished booting its isActive
    // state yet in this same tick -- setting drawer here directly is silently
    // ignored.
    this.$nextTick(() => {
      if (this.$vuetify.breakpoint.mobile) this.drawer = false;
    });
  },
  computed: {
    ...mapGetters("app", ["title"]),
    activePrimaryMenuItems() {
      return this.allPrimaryMenuItems.filter(
        (item) => !item.adminOnly || this.$auth.user.is_admin
      );
    },
    activeSecondaryMenuItems() {
      return this.allSecondaryMenuItems.filter(
        (item) => !item.adminOnly || this.$auth.user.is_admin
      );
    },
    activeAccountMenuItems() {
      return this.accountMenuItems.filter(
        (item) => !item.adminOnly || this.$auth.user.is_admin
      );
    },
    userName() {
      if (!this.$auth.loggedIn) return "";
      return this.$auth.user.first_name;
    },
  },
  methods: {
    decorateTo(to) {
      if (to && to.indexOf("{current_user}") !== -1) {
        to = to.replace("{current_user}", this.$auth.user.id);
      }
      return to;
    },
  },
};
